// extracted by mini-css-extract-plugin
module.exports = {"label":"LabeledInputs-module--label--1lXCv","input":"LabeledInputs-module--input--Ql6ws"};